export const generateSocialTags = (title, description, type, url, image) => {
  const twitterTags = [
    {
      name: 'twitter:card',
      content: 'summary_large_image'
    },
    {
      name: 'twitter:title',
      content: title
    },
    {
      name: 'twitter:description',
      content: description
    },
    {
      name: 'twitter:site',
      content: '@DotComRecovery'
    }
  ]

  if (image) {
    twitterTags.push({
      name: 'twitter:image',
      content: image
    })
  }

  const ogTags = [
    {
      property: 'og:title',
      content: title
    },
    {
      property: 'og:description',
      content: description
    },
    {
      property: 'og:type',
      content: type
    },
    {
      property: 'og:url',
      content: url
    },
    {
      property: 'og:locale',
      content: 'en_US'
    }
  ]

  if (image) {
    ogTags.push(
      {
        property: 'og:image',
        content: image
      },
      {
        property: 'og:image:width',
        content: '1200'
      },
      {
        property: 'og:image:height',
        content: '630'
      }
    )
  }

  const allTags = [...ogTags, ...twitterTags]

  return allTags
}
